module.exports = __webpack_public_path__ + "static/img/SFU老师_Alex.356323e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/studentLanding/SFU/SFU老师_Alex.png
// module id = yWku
// module chunks = 0